import { FC } from 'react';
import { Box, IconButton } from '@mui/material';
import { hostColorSelectItemStyles, hostColorSelectRowStyles } from './host-color-select.styles';
import { Colors, HostGradients } from '../../../constants';
import { CheckmarkIcon } from '../../../icons';

export const defaultHostColorsArray = Object.entries(HostGradients).map(([colorId, background]) => ({
	id: colorId,
	background,
}));

export interface HostColorSelectProps {
	colors?: { id: string; background: string }[];
	selectedColorId?: string | null;
	disabled?: boolean;
	onChange?(colorId: string): void;
}

export const HostColorSelect: FC<HostColorSelectProps> = ({
	selectedColorId = Colors.orange,
	colors = defaultHostColorsArray,
	disabled,
	onChange: onSelectColor,
}) => (
	<Box sx={hostColorSelectRowStyles}>
		{colors.map((color) => (
			<IconButton
				key={color.id}
				sx={hostColorSelectItemStyles(color.background, selectedColorId === color.id)}
				disabled={disabled}
				onClick={() => {
					onSelectColor?.(color.id);
				}}
			>
				{selectedColorId === color.id && (
					<Box component={CheckmarkIcon} sx={{ width: '20px', height: '20px', color: 'white' }} />
				)}
			</IconButton>
		))}
	</Box>
);
